export const COMMAND_AUTH_INIT = 'auth_init';
export const COMMAND_AUTH_RESULT = 'auth_result';
export const COMMAND_CURRENT_USER_TOKEN = 'current_user_token';
export const COMMAND_ERROR = 'error';
export const COMMAND_ACTIVATED = 'activated';
export const COMMAND_AUTH_DECLINED = 'declined';
export const COMMAND_CONNECTION_FAILED = 'connection_failed';
export const HTTP_HEADERS = {
  'Accept': 'application/json, text/plain, */*',
  'Content-Type': 'application/json',
};
